<script setup lang="ts">
import OpeningHoursForm from './stores/OpeningHoursForm.vue'
import StoreItems from './stores/StoresItems.vue'

type StoresTab = 'stores' | 'hours'

const { stores, isSupportConnection } = useLocalStorage()
const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const tabFromQuery = (): StoresTab => {
  const tab = Array.isArray(route.query.tab) ? route.query.tab[0] : route.query.tab
  return tab === 'hours' && isSupportConnection.value ? 'hours' : 'stores'
}

const currentTab = ref<StoresTab>(tabFromQuery())

watch(
  () => [route.query.tab, isSupportConnection.value] as const,
  () => {
    const nextTab = tabFromQuery()
    if (currentTab.value !== nextTab) {
      currentTab.value = nextTab
    }
  }
)

watch(currentTab, (tab) => {
  const queryTab = tabFromQuery()
  if (tab === queryTab) {
    return
  }

  const query = { ...route.query }
  if (tab === 'stores') {
    delete query.tab
  } else {
    query.tab = tab
  }

  router.replace({ query })
})

watch(
  isSupportConnection,
  (isSupport) => {
    if (isSupport || route.query.tab !== 'hours') {
      return
    }

    const query = { ...route.query }
    delete query.tab
    router.replace({ query })
  },
  { immediate: true }
)
</script>

<template>
  <div>
    <TheListHeader :title="t('pages.settings.storesPage.title')" />

    <Tabs v-model="currentTab" class="px-6 sm:px-12">
      <TabsList variant="underline">
        <TabsTrigger variant="underline" value="stores">
          {{ t('pages.settings.storesPage.tabs.stores') }}
        </TabsTrigger>
        <TabsTrigger v-if="isSupportConnection" variant="underline" value="hours">
          {{ t('pages.settings.storesPage.tabs.hours') }}
        </TabsTrigger>
      </TabsList>

      <TabsContent value="stores">
        <StoreItems :stores="stores" />
      </TabsContent>

      <TabsContent v-if="isSupportConnection" value="hours">
        <OpeningHoursForm v-if="currentTab === 'hours'" />
      </TabsContent>
    </Tabs>
  </div>
</template>
